import React, { useState } from 'react';
import axios from 'axios';
import Dashboard from "../Adminsidebar/AdminSidebar";
import { getToken } from '../Login/Authutils';
import './Changepassword.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [passwordStrength, setPasswordStrength] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);

  const backendUrl = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; 

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    const token = getToken();
    if (!token) {
      setError('Authentication token not found. Please login again.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New password and confirm password do not match.');
      return;
    }

    if (passwordStrength !== 'Perfect' && passwordStrength !== 'Good') {
      setError('New password does not meet strength requirements.');
      return;
    }

    try {
      const response = await axios.post(
        `${backendUrl}/change-password`,
        { currentPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMessage(response.data.message || 'Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPasswordStrength('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to change password');
    }
  };

  const checkPasswordStrength = (password) => {
    if (password.length < 8) return 'Weak';
    if (password.length < 12) {
      return /[0-9]/.test(password) || /[^a-zA-Z0-9]/.test(password) ? 'Normal' : 'Weak';
    }
    return /[0-9]/.test(password) && /[^a-zA-Z0-9]/.test(password) && /[A-Z]/.test(password)
      ? 'Perfect'
      : 'Good';
  };

  const handleNewPasswordChange = (e) => {
    const pwd = e.target.value;
    setNewPassword(pwd);
    setPasswordStrength(checkPasswordStrength(pwd));
  };

  return (
    <>
      <Dashboard />
      <div className="change-password-container">
        <h2 className="change-password-title">Change Password</h2>
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleChangePassword} className="change-password-form">
          <div className="form-group">
            <label htmlFor="currentPassword">Current Password:</label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">New Password:</label>
            <div className="password-input-container">
              <input
                type={showNewPassword ? 'text' : 'password'}
                id="newPassword"
                value={newPassword}
                onChange={handleNewPasswordChange}
                required
                className="password-input"
              />
              <button
                type="button"
                className="password-toggle-button"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                <FontAwesomeIcon icon={showNewPassword ? faEyeSlash : faEye} />
              </button>
            </div>
            {passwordStrength && (
              <div className={`password-strength ${passwordStrength.toLowerCase()}`}>
                Password Strength: {passwordStrength}
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password:</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-button">
            Change Password
          </button>
        </form>
      </div>
    </>
  );
};

export default ChangePassword;
